import { Check } from "lucide-react";

const STEPS = [
  { id: 1, label: "Select Vehicle", short: "Vehicle" },
  { id: 2, label: "Extras & Insurance", short: "Extras" },
  { id: 3, label: "Checkout & Details", short: "Checkout" },
];

/**
 * WizardSteps (v4.5.3) — segmented pill tabs for the public booking flow.
 * No borders or dividers: a single rounded tray holds three equal tabs, the
 * active one lifted on a white card. Visited steps stay clickable so
 * customers can hop back without losing their dates, car or form entries.
 */
export default function WizardSteps({ current, maxStep, onSelect, scope = "pb-wizard" }) {
  return (
    <nav
      className="bg-neutral-100 dark:bg-neutral-800 p-1.5 rounded-2xl flex items-center gap-1 w-full max-w-2xl mx-auto"
      data-testid={`${scope}-steps`}
      aria-label="Booking steps"
    >
      {STEPS.map(({ id, label, short }) => {
        const active = id === current;
        const done = id !== current && id <= maxStep;
        const clickable = id <= maxStep && !active;
        return (
          <button
            key={id}
            type="button"
            disabled={!clickable}
            onClick={() => clickable && onSelect(id)}
            data-testid={`${scope}-step-${id}`}
            data-state={active ? "active" : done ? "done" : "locked"}
            aria-current={active ? "step" : undefined}
            className={`rounded-xl py-2 px-2 sm:px-4 flex-1 min-w-0 text-center transition-all ${
              active
                ? "bg-white dark:bg-neutral-900 text-neutral-900 dark:text-white font-semibold shadow-sm"
                : done
                  ? "text-neutral-700 dark:text-neutral-300 hover:bg-white/60 dark:hover:bg-neutral-700/60 cursor-pointer active:scale-[0.98]"
                  : "text-neutral-400 dark:text-neutral-500 cursor-default"
            }`}
          >
            <span className="inline-flex items-center justify-center gap-1.5 sm:gap-2 min-w-0 max-w-full">
              <span
                className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-semibold tabular-nums shrink-0 transition-colors ${
                  active
                    ? "bg-neutral-900 text-white dark:bg-white dark:text-neutral-900"
                    : done
                      ? "bg-neutral-900/10 text-neutral-700 dark:bg-white/15 dark:text-neutral-200"
                      : "bg-neutral-200/80 text-neutral-400 dark:bg-neutral-700 dark:text-neutral-500"
                }`}
              >
                {done ? <Check size={11} strokeWidth={3} /> : id}
              </span>
              <span className="text-[10px] sm:text-[11px] md:text-xs tracking-wide uppercase whitespace-nowrap">
                <span className="sm:hidden">{short}</span>
                <span className="hidden sm:inline">{label}</span>
              </span>
            </span>
          </button>
        );
      })}
    </nav>
  );
}
